import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useAuthStore } from '../store/useAuthStore';
import { COMMAND_CENTER_URL } from '../lib/commandCenter';

const TRIGGER = 'jarvis';

/**
 * Super-admin easter egg: typing "jarvis" anywhere in the app (outside a text
 * field) opens the Avium Command Center HUD in a new tab. Renders nothing and
 * no-ops entirely for non-super-admins. The destination is gated by Cloudflare
 * Access, so it only ever opens for Brian even if triggered elsewhere.
 */
export default function CommandCenterEasterEgg() {
  const { isSuperAdmin } = useAuthStore();
  const enabled = isSuperAdmin();

  useEffect(() => {
    if (!enabled) return;
    let buffer = '';
    const onKey = (e: KeyboardEvent) => {
      const el = document.activeElement;
      if (
        el instanceof HTMLInputElement ||
        el instanceof HTMLTextAreaElement ||
        (el instanceof HTMLElement && el.isContentEditable)
      ) return;
      if (e.key.length !== 1 || e.metaKey || e.ctrlKey || e.altKey) return;
      buffer = (buffer + e.key.toLowerCase()).slice(-TRIGGER.length);
      if (buffer === TRIGGER) {
        buffer = '';
        // No 'noopener' so we can detect a blocked pop-up and tell the user,
        // rather than failing silently (the old bug). The destination is our
        // own Access-gated HUD, so reverse-tabnabbing isn't a concern here.
        const win = window.open(COMMAND_CENTER_URL, '_blank');
        if (!win) {
          toast.error('Command Center couldn’t open — allow pop-ups for this site, then type “jarvis” again.');
        }
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [enabled]);

  return null;
}
